import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { ML_MODEL_PATHS } from './paths';

/**
 * ML-модель: «psychology» из Material Symbols (Apache 2.0) — голова с шестерёнкой,
 * общепринятая пиктограмма AI/ML. В @material-ui/icons 4.x этой иконки ещё нет.
 */
export const MlModelIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {ML_MODEL_PATHS.map(d => (
      <path key={d} d={d} />
    ))}
  </SvgIcon>
);
